// initial state
const state = () => ({
  toastMessage: null,
})

// mutations
const mutations = {
  setToastMessage(state, payload) {
    state.toastMessage = payload
  },

  resetToastMessage(state) {
    state.toastMessage = null
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
